import { useContextSelector } from "use-context-selector";
import { RemoteParticipantContext } from "../context/RemoteParticipantContext";
import { VideoChatContext } from "../context/VideoChatContext";

export const useRemoteParticipant = () => {
  const remoteParticipant = useContextSelector(
    VideoChatContext,
    (context) => context.remoteParticipant
  );
  const setRemoteParticipant = useContextSelector(
    VideoChatContext,
    (context) => context.handleSetRemoteParticipant
  );

  const localRemoteVideoOff = useContextSelector(
    RemoteParticipantContext,
    (context) => context.localRemoteVideoOff
  );
  const localRemoteAudioOff = useContextSelector(
    RemoteParticipantContext,
    (context) => context.localRemoteAudioOff
  );

  const handleLocalRemoteVideo = useContextSelector(
    RemoteParticipantContext,
    (context) => context.handleLocalRemoteVideo
  );
  const handleLocalRemoteAudio = useContextSelector(
    RemoteParticipantContext,
    (context) => context.handleLocalRemoteAudio
  );

  const networkQualityLevelRemote = useContextSelector(
    RemoteParticipantContext,
    (context) => context.networkQualityLevelRemote
  );

  const setNetworkQualityLevelRemote = useContextSelector(
    RemoteParticipantContext,
    (context) => context.setNetworkQualityLevelRemote
  );

  const isOnBackground = useContextSelector(
    RemoteParticipantContext,
    (context) => context.isOnBackground
  );

  const handleOnBackground = useContextSelector(
    RemoteParticipantContext,
    (context) => context.handleOnBackground
  );

  return {
    remoteParticipant,
    setRemoteParticipant,
    localRemoteVideoOff,
    localRemoteAudioOff,
    handleLocalRemoteVideo,
    handleLocalRemoteAudio,
    networkQualityLevelRemote,
    setNetworkQualityLevelRemote,
    isOnBackground,
    handleOnBackground,
  };
};
